import type { BaseTextData } from '@/teoCore/TeoStorage';

export class GeneratorHistoryEntry {
  instructions: string;
  generatorError: Maybe<{ message: string }>;
  textData: Maybe<BaseTextData>;
  locked: boolean;

  constructor(initialState?: Partial<GeneratorHistoryEntry>) {
    this.instructions = initialState?.instructions || '';
    this.generatorError = initialState?.generatorError || null;
    this.textData = initialState?.textData || null;
    this.locked = initialState?.locked ?? false;
  }

  toJSON() {
    return {
      instructions: this.instructions,
      generatorError: null,
      textData: this.textData ? { ...this.textData } : undefined,
      locked: this.locked,
    } as const;
  }

  clone(): GeneratorHistoryEntry {
    return new GeneratorHistoryEntry(structuredClone(this.toJSON()));
  }
}
